import React from 'react';
import ProjectList from './ProjectList';

const Projects = () => {
  return <ProjectList />;
};

export default Projects;
